"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAdminUserDto = instanceOfAdminUserDto;
exports.AdminUserDtoFromJSON = AdminUserDtoFromJSON;
exports.AdminUserDtoFromJSONTyped = AdminUserDtoFromJSONTyped;
exports.AdminUserDtoToJSON = AdminUserDtoToJSON;
exports.AdminUserDtoToJSONTyped = AdminUserDtoToJSONTyped;
/**
 * Check if a given object implements the AdminUserDto interface.
 */
function instanceOfAdminUserDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('fullName' in value) || value['fullName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('isVerified' in value) || value['isVerified'] === undefined)
        return false;
    if (!('propertyListed' in value) || value['propertyListed'] === undefined)
        return false;
    if (!('offersBidsGiven' in value) || value['offersBidsGiven'] === undefined)
        return false;
    if (!('offersBidsReceived' in value) || value['offersBidsReceived'] === undefined)
        return false;
    if (!('isDisabled' in value) || value['isDisabled'] === undefined)
        return false;
    return true;
}
function AdminUserDtoFromJSON(json) {
    return AdminUserDtoFromJSONTyped(json, false);
}
function AdminUserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fullName': json['fullName'],
        'email': json['email'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'isVerified': json['isVerified'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'propertyListed': json['propertyListed'],
        'offersBidsGiven': json['offersBidsGiven'],
        'offersBidsReceived': json['offersBidsReceived'],
        'isDisabled': json['isDisabled'],
    };
}
function AdminUserDtoToJSON(json) {
    return AdminUserDtoToJSONTyped(json, false);
}
function AdminUserDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fullName': value['fullName'],
        'email': value['email'],
        'countryCode': value['countryCode'],
        'phoneNumber': value['phoneNumber'],
        'isVerified': value['isVerified'],
        'avatarUrl': value['avatarUrl'],
        'propertyListed': value['propertyListed'],
        'offersBidsGiven': value['offersBidsGiven'],
        'offersBidsReceived': value['offersBidsReceived'],
        'isDisabled': value['isDisabled'],
    };
}
